module.exports = __webpack_public_path__ + "static/media/hall-P11.7bbbff35.svg";